<template>
    <div>
 <v-card flat>

        <v-card-text style="margin: 0; padding: 0">
            <v-layout justify-start wrap>


                <v-flex xs12 md4 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                     <v-list subheader>
                    <v-subheader style="background: #f0f0f0">Subscriptions
                    </v-subheader>
                    <v-list-tile v-for="subscription in subscriptions" :key="subscription.id">
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 14px">
                                {{subscription.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title style="font-size: 14px">
                                {{subscription.gluePlan.type}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action style="font-size: 12px">
                            {{subscription.gluePlan.pricePerUnit | currency}} per unit
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-subheader style="background: #f0f0f0">Indicative Monthly Fee <span v-if="indicativeBilling.period" style="font-size: 12px">: {{indicativeBilling.period}}</span>
                        <v-spacer></v-spacer>
                        <span v-if="indicativeBilling&&indicativeBilling.period">{{CalculateIndicativeBilling(subscriptions) | currency}}</span>
                    </v-subheader>
                    <v-list-tile v-for="subscription in subscriptions" :key="subscription.id">
                        <v-list-tile-action style="width: 150px">
                            <v-chip v-if="subscription.gluePlan.type =='Active Service Accounts'">
                                {{indicativeBilling.gluePercentage.toFixed(2)}}
                            </v-chip>
                            <v-chip v-else-if="subscription.gluePlan.type =='Installed Locations'">
                                {{indicativeBilling.unitsConnected}}
                            </v-chip>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 14px">
                                {{subscription.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title style="font-size: 14px">
                                {{subscription.gluePlan.type}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action style="font-size: 12px">
                            <span v-if="subscription.gluePlan.type =='Active Service Accounts'">
                                {{subscription.gluePlan.pricePerUnit*indicativeBilling.gluePercentage.toFixed(2) | currency}}
                            </span>
                            <span v-else-if="subscription.gluePlan.type =='Installed Locations'">
                                {{subscription.gluePlan.pricePerUnit*indicativeBilling.unitsConnected | currency}}
                            </span>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
                </v-flex>


                <v-flex xs12 md4 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader>
                 <v-subheader style="background: #f0f0f0">Digital Documents
                    </v-subheader>
                    <v-list-tile v-for="document in organisationAgreements" :key="document.id" @click="downloadContent(document)">
                        <v-list-tile-content>
                            <v-list-tile-title style="font-size: 14px">
                                {{document.name}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title style='font-size: 14px'>
                                {{document.assignedTo.name}} {{document.assignedTo.surname}} <span v-if="!document.acceptedDate"> | Due {{document.date}}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-icon v-if="!document.accepted" color="orange">warning</v-icon>
                            <v-icon v-else color="green">check_circle_outline</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile v-if="organisationAgreements.length==0">
                        <v-list-tile-sub-title style='font-size: 14px'>
                            No digital documents
                        </v-list-tile-sub-title>
                    </v-list-tile>
                </v-list>

                </v-flex>



            </v-layout>
        </v-card-text>
 </v-card>

    </div>
</template>
<script>
import Api from "@/services/Api";
export default {
    props: ['organisation', 'billingSettings'],
    data: ()=>({
        indicativeBilling: {},
        organisationAgreements: [],
        subscriptions: [],
        xeroInvoices: []
    }),
    created(){
                // if (this.organisation.xeroContactId) {
                //     this.getXeroInvoices(this.organisation.xeroContactId)
                // }
                this.getOrganisationSubscriptions()
                this.getOrganisationAgreements()
                let billing = this.getBillingDates(this.billingSettings.billingDay, this.billingSettings.includeBillingDay)
                this.billingSettings.startDate = billing.startDate
                this.billingSettings.endDate = billing.endDate
                this.getIndicativeBilling(billing.startDate, billing.endDate)
    },
    methods: {
        
        CalculateIndicativeBilling(subscriptions) {
            let result = 0
            for (let i = 0; i < subscriptions.length; i++) {
                if (subscriptions[i].gluePlan.type == 'Active Service Accounts') {
                    result += subscriptions[i].gluePlan.pricePerUnit * this.indicativeBilling.gluePercentage.toFixed(2)
                } else if (subscriptions[i].gluePlan.type == 'Installed Locations') {
                    result += subscriptions[i].gluePlan.pricePerUnit * this.indicativeBilling.unitsConnected
                }
            }
            return result
        },
         getOrganisationAgreements(id) {
            Api().get('/agreements/organisation' ).then(res => {
                this.organisationAgreements = res.data
                console.log(this.organisationAgreements)
                this.agreementKey++
            })
        },
        getOrganisationSubscriptions() {
            Api().get('/subscription').then(res => {
                this.subscriptions = res.data
            })
        },
        getIndicativeBilling(start, end) {
            Api().post('/billingSummary/glue/indicative', {
                billingStart: start,
                billingEnd: end
            }).then(res => {
                console.log(res.data)
                this.indicativeBilling = res.data
            })
        },
        downloadContent(item) {
            Api().get('/download/agreements/' + item.id).then(response => {
                let linkSource = `${response.data}`;
                if(!response.data.includes('base64')){
                    linkSource = `data:application/pdf;base64,${response.data}`;
                }
                const downloadLink = document.createElement("a");
                const fileName = item.name + '.pdf'

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
        },
        getBillingDates(billingDay, includeBillingDay) {
            var today = new Date()
            let startDate = null
            let endDate = null
            switch (billingDay) {
                case '1st':
                    today.setMonth(today.getMonth())
                    today.setDate(1)
                    console.log(today)
                    var eom = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    console.log('From ' + today.getDate() + ' to ' + eom.getDate())
                    startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                    startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                    return {
                        startDate: startDate, endDate: endDate
                    }
                    case '7th':
                        if (includeBillingDay) {
                            today.setDate(8)
                        } else {
                            today.setDate(7)
                        }
                        today.setMonth(today.getMonth() - 2)
                        var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                        eom.setDate(today.getDate() - 1)
                        startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                        endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                        return {
                            startDate: startDate, endDate: endDate
                        }
                        case '15th':
                            if (includeBillingDay) {
                                today.setDate(16)
                            } else {
                                today.setDate(15)
                            }
                            today.setMonth(today.getMonth() - 1)
                            var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                            eom.setDate(today.getDate() - 1)
                            startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                            endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                            return {
                                startDate: startDate, endDate: endDate
                            }
                            case '25th':
                                if (includeBillingDay) {
                                    today.setDate(26)
                                } else {
                                    today.setDate(25)
                                }
                                today.setMonth(today.getMonth() - 1)
                                var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                                eom.setDate(today.getDate() - 1)
                                startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                                endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                                return {
                                    startDate: startDate, endDate: endDate
                                }
            }
        },
        getXeroInvoices(xeroContactId) {
            Api().get('/xero/admin/invoices/' + xeroContactId).then(res => {
                this.xeroInvoices = res.data.body.invoices.map(x => ({
                    invoiceNumber: x.invoiceNumber,
                    date: x.date,
                    dueDate: x.dueDate,
                    status: x.status,
                    subtotal: x.subTotal,
                    total: x.total,
                    totalTax: x.totalTax,
                    amountPaid: x.amountPaid,
                    amountDue: x.amountDue
                }))
            })
        },
    }
}
</script>